// Fiche d'un rapport briques & pavés (consultation, impression ; correction et suppression par le responsable).
import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, GlobalStyles, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { DeleteOutline, EditOutlined, PrintOutlined } from '@mui/icons-material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/Layout';
import { Panel } from '../../components/ui';
import { briquesAPI } from '../../services/api';
import { apiError, dateFr, dateHeureFr } from '../../utils/format';
import { tokens } from '../../theme';

const nb = (n) => Number(n || 0).toLocaleString('fr-FR');
const Tab2 = ({ rows, head }) => (
  <Table size="small">
    {head && <TableHead><TableRow>{head.map((h, i) => <TableCell key={h} align={i ? 'right' : 'left'}>{h}</TableCell>)}</TableRow></TableHead>}
    <TableBody>{rows.map((r) => <TableRow key={r[0]}>{r.map((c, i) => <TableCell key={i} align={i ? 'right' : 'left'} sx={i ? { fontFamily: tokens.mono, whiteSpace: 'nowrap' } : {}}>{c}</TableCell>)}</TableRow>)}</TableBody>
  </Table>
);

const RapportBriques = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [r, setR] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => { briquesAPI.rapport(id).then((x) => setR(x.data)).catch((e) => setError(apiError(e))); }, [id]);

  if (!r) return <Layout title="Rapport briques & pavés">{error ? <Alert severity="error">{error}</Alert> : 'Chargement…'}</Layout>;
  const mats = Object.entries(r.materiaux || {});
  const pers = Object.entries(r.personnel || {});
  const supprimer = async () => {
    if (!window.confirm(`Supprimer le rapport ${r.numero} du ${dateFr(r.report_date)} ?`)) return;
    try { await briquesAPI.supprimer(id); navigate('/briques/rapports', { state: { info: `Rapport ${r.numero} supprimé` } }); } catch (e) { setError(apiError(e)); }
  };

  return (
    <Layout title={`Rapport briques & pavés du ${dateFr(r.report_date)}`} plain
      actions={(
        <>
          <Button startIcon={<PrintOutlined />} onClick={() => window.print()}>Imprimer</Button>
          {r.gestion && <Button startIcon={<EditOutlined />} onClick={() => navigate(`/briques/rapports/${id}/modifier`)}>Corriger</Button>}
          {r.gestion && <Button color="error" startIcon={<DeleteOutline />} onClick={supprimer}>Supprimer</Button>}
        </>
      )}>
      <GlobalStyles styles={{ '@media print': { 'nav, aside, .MuiDrawer-root, .no-print, button': { display: 'none !important' }, body: { background: '#fff !important' } } }} />
      {location.state?.info && <Alert className="no-print" severity="success" sx={{ mb: 2 }}>{location.state.info}</Alert>}
      {error && <Alert className="no-print" severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>{error}</Alert>}
      <Box sx={{ display: 'none', '@media print': { display: 'block' }, mb: 2, borderBottom: '2px solid #12284C', pb: 1 }}>
        <b>DOCC SAS</b> — Unité briques & pavés — Rapport {r.numero} du {dateFr(r.report_date)}
      </Box>
      <Typography color="text.secondary" sx={{ mb: 2 }}>
        {r.numero} · par {[r.employee_firstname, r.employee_name].filter(Boolean).join(' ') || '—'} · saisi par {r.saisi_par || '—'} le {dateHeureFr(r.created_at)}
        {r.modifie_par ? ` · corrigé par ${r.modifie_par} le ${dateHeureFr(r.updated_at)}` : ''}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <Panel title={`Production : ${nb(r.total)}`} flush>
            {r.lignes.length ? (
              <Tab2 head={['Article', 'Produit', 'Rebut']} rows={r.lignes.map((l) => [l.designation, `${nb(l.quantite)} ${l.unite}`, l.rebut ? nb(l.rebut) : '—'])} />
            ) : <Typography sx={{ p: 2, color: 'text.secondary' }}>Aucune production.</Typography>}
          </Panel>
        </Grid>
        <Grid item xs={12} md={5}>
          <Panel title="Matériaux utilisés" flush sx={{ mb: 2 }}>
            {mats.length ? <Tab2 rows={mats.map(([k, v]) => [k, `${v.q}${v.unite ? ` ${v.unite}` : ''}`])} /> : <Typography sx={{ p: 2, color: 'text.secondary' }}>—</Typography>}
          </Panel>
          <Panel title={`Personnel : ${pers.reduce((s, [, n]) => s + n, 0)}`} flush>
            {pers.length ? <Tab2 rows={pers.map(([k, v]) => [k, v])} /> : <Typography sx={{ p: 2, color: 'text.secondary' }}>—</Typography>}
          </Panel>
        </Grid>
        {r.observations && (
          <Grid item xs={12}>
            <Panel title="Observations"><Typography sx={{ whiteSpace: 'pre-line' }}>{r.observations}</Typography></Panel>
          </Grid>
        )}
      </Grid>
    </Layout>
  );
};

export default RapportBriques;
